import React from 'react';
import { cashierCtrl } from '../../cashier.controller';
import { IUICashierFormValues } from '../../cashier.interface';
import CashierActionButton, { ActionType } from '../../components/CashierActionButton';
import ModalMultiplePayments, { ModalMultiplePaymentRef } from './ModalMultiplePayments';
type Props = {
  discountSetting: IUICashierFormValues['cashIncentive'],
  enableCashIncentive: IUICashierFormValues['cashIncentiveDiscount'],
  enableCardFee: IUICashierFormValues['chargeFee'],
};
export const cashierBtnMultiPayV3 = React.createRef<ModalMultiplePaymentRef>();
const CashierMultiPayment = ({ discountSetting, enableCardFee, enableCashIncentive }: Props) => {
  const onClick = async () => {
    cashierCtrl.saveTicketPaymentWithCallBack((billId) => {
      if (billId) cashierBtnMultiPayV3.current?.open(billId);
    });
  };

  return (
    <>
      <CashierActionButton
        type={ActionType.MULTI_PAY}
        onClick={onClick}
      />
      <ModalMultiplePayments
        ref={cashierBtnMultiPayV3}
        discountSetting={discountSetting}
        enableCardFee={enableCardFee}
        enableCashIncentive={enableCashIncentive}
      />
    </>
  );
};

export default CashierMultiPayment;
